var _defs, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfantToddler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x37_09-plus_x40_2x.png",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #06874c;\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Green-Circle",
    className: "st0",
    cx: 15.9,
    cy: 15.9,
    r: 15.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "I_x2013_T"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.7,12.5h1.2v7h-1.2v-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.4,15.9h4.2v1.1h-4.2v-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.9,13.6h-2.2v-1.1h5.7v1.1h-2.2v5.9h-1.2v-5.9Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfantToddler);
export default __webpack_public_path__ + "static/media/infantToddler.54dbccc13eb1aacb3adc4768c54c0b61.svg";
export { ForwardRef as ReactComponent };